namespace $.$$ {
	export class $shm_showcase_demo_echarts extends $.$shm_showcase_demo_echarts {
		@ $mol_mem
		option() {
			return {
				tooltip: { trigger: 'axis' },
				legend: { data: [ 'Посещения' ] },
				xAxis: { type: 'category', data: [ 'Пн', 'Вт', 'Ср', 'Чт', 'Пт' ] },
				yAxis: { type: 'value' },
				series: [ { name: 'Посещения', type: this.kind(), data: [ 120, 180, 150, 240, 210 ] } ],
			}
		}
	}
}
